/**
 * AliHelper — shopping assistant on AliExpress
 *
 * A single web-accessible-resource group exposes images/*, fonts/* and the three PNG
 * icons, but scoped to AliExpress origins only (.com / .ru / .us), not to every page.
 * With no use_dynamic_url the URLs are fixed, so from AliExpress the icons are fetchable
 * — but from any other origin the resources are unreachable and a negative proves
 * nothing.
 *
 * Manifest verified against version 3.1.7.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'ojclfkinnapkabameogjppmeedlicean';

export const aliHelper: ExtensionDefinition = {
  id: ID,
  name: 'AliHelper – shopping assistant on AliExpress ™',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  requiredOrigin: 'https://www.aliexpress.com',
  notes:
    'WAR scoped to AliExpress origins, not exposed to every page. The 128.png icon is ' +
    'static, so only an AliExpress page can detect it here.',
  signals: [
    {
      id: 'war-icon-128',
      kind: 'web-accessible-resource',
      description:
        'Fetch 128.png — the extension icon, exposed only to AliExpress origins at a ' +
        'fixed URL.',
      weight: 1,
      run: () => probeFetch(ID, '128.png'),
    },
    {
      id: 'war-icon-48',
      kind: 'web-accessible-resource',
      description: 'Fetch 48.png — a second static icon on the same scoped group.',
      weight: 0.5,
      run: () => probeFetch(ID, '48.png'),
    },
  ],
};
